"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAllCollectionsCollectionResult = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _ActionTypes = require("./ActionTypes");

var ecosystemClient = _interopRequireWildcard(require("../clients/ecosystemClient"));

var StorefrontCollection = _interopRequireWildcard(require("../constants/StorefrontCollection"));

var _AllCollectionsResults = require("../records/AllCollectionsResults");

var _earlyRequests = require("../utils/earlyRequests");

var fetchAllCollectionsCollectionResult = function fetchAllCollectionsCollectionResult(collection) {
  return function (dispatch) {
    var earlyRequestName = (0, _earlyRequests.getAllCollectionsEarlyRequestName)(collection);
    dispatch({
      type: _ActionTypes.ALL_COLLECTIONS_COLLECTION_FETCH_REQUESTED,
      meta: {
        collection: collection
      }
    });
    return (0, _earlyRequests.maybeEarlyRequest)(earlyRequestName, function () {
      var query = (0, _AllCollectionsResults.getCollectionSearchQuery)(collection);
      return ecosystemClient.search((0, _extends2.default)({}, query, {
        includePieSyncConnectors: collection === StorefrontCollection.PIESYNC
      }));
    }).then(function (result) {
      dispatch({
        type: _ActionTypes.ALL_COLLECTIONS_COLLECTION_FETCH_RECEIVED,
        payload: result,
        meta: {
          collection: collection
        }
      });
      return result;
    }).catch(function (error) {
      dispatch({
        type: _ActionTypes.ALL_COLLECTIONS_COLLECTION_FETCH_FAILED,
        payload: error,
        meta: {
          collection: collection
        }
      });
      throw error;
    });
  };
};

exports.fetchAllCollectionsCollectionResult = fetchAllCollectionsCollectionResult;


//////////////////
// WEBPACK FOOTER
// ./js/actions/StorefrontActions.js
// module id = 888
// module chunks = 209 210 211 212